import { render, staticRenderFns } from "./proComplianceReasonForChange.vue?vue&type=template&id=2111fe21&"
import script from "./proComplianceReasonForChange.vue?vue&type=script&lang=js&"
export * from "./proComplianceReasonForChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports